import React from 'react';
import { useMainSignatoryReadQuery } from 'common-app/api/query/main-signatory-read';
import { useSignatoryReadQuery } from 'common-app/api/query/signatory-read';
import { Spinner } from '@isyc-react/design/bootstrap';
import { ErrorContentLayout } from 'layout';
import { DossierSummary } from './dossier-summary.component';
import { useOccupantReadQuery } from 'common-app/api/query/occupant-read';
import { useDossierContext } from 'common-app/dossier';
import { useDossierErrorsQuery } from 'common/api';
import { DossierErrors } from '../errors';
export const DossierSummaryContainer = () => {
    const { dossier } = useDossierContext();
    const { data: mainSignatory, loading: loadingMainSignatory } = useMainSignatoryReadQuery({
        variables: { dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id },
    });
    const { data: signatories, loading: loadingSignatories } = useSignatoryReadQuery({
        variables: { dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id },
    });
    const { data: occupants, loading: loadingOccupants } = useOccupantReadQuery({ variables: { dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id } });
    const { data: dossierErrorsData, loading: dossierErrorsLoading } = useDossierErrorsQuery({
        variables: {
            dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id,
        },
    });
    const dossierErrors = React.useMemo(() => {
        if (dossierErrorsData && dossierErrorsData.dossier_errors) {
            return dossierErrorsData.dossier_errors;
        }
        return undefined;
    }, [dossierErrorsData]);
    return (React.createElement(React.Fragment, null, loadingMainSignatory || loadingSignatories || loadingOccupants || dossierErrorsLoading ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
            React.createElement(Spinner, { animation: 'border' })))) : (React.createElement(React.Fragment, null, (mainSignatory === null || mainSignatory === void 0 ? void 0 : mainSignatory.read_main_signatory) && (signatories === null || signatories === void 0 ? void 0 : signatories.read_signatory) && (occupants === null || occupants === void 0 ? void 0 : occupants.read_occupant) ? (React.createElement(React.Fragment, null,
        dossierErrors && dossierErrors.length > 0 && React.createElement(DossierErrors, { errors: dossierErrors }),
        React.createElement(DossierSummary, { main: mainSignatory.read_main_signatory, signatories: signatories.read_signatory, occupants: occupants.read_occupant, hasErrors: (dossierErrors ? dossierErrors.length : 0) > 0 }))) : (React.createElement(ErrorContentLayout, null,
        React.createElement("h1", { className: 'text-primary' }, "Erreur de r\u00E9capitulatif"),
        React.createElement("p", null, "Impossible d'obtenir les donn\u00E9es du r\u00E9capitulatif")))))));
};
